import React from "react";

const RockyTransition = ({ green, height }) => {
  return (
    <svg
      width="373"
      height={height || "118"}
      viewBox="0 0 373 118"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`w-full absolute -mt-12 ${
        green ? "rockyGreen rockyTransition " : "rockyTransition"
      }`}
    >
      <path d="M332.893 20L373 10V118H-1.00003V20L14.0402 10L39.1072 20H48.1313L57.1555 10L71.193 20H94.2547L110.298 32L171.461 20L187.504 5L223.601 0L232.625 10H244.657L258.694 5L293.788 20L302.812 10L332.893 20Z" />
      <defs>
        <linearGradient
          id="whiteGradient"
          x1="186"
          y1="0"
          x2="186"
          y2="118"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.5" />
          <stop offset="0.0001" stopColor="white" stopOpacity="0.5" />
          <stop offset="0.171875" stopColor="white" stopOpacity="0.8" />
          <stop offset="0.375" stopColor="white" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="greenGradient"
          x1="0"
          y1="118"
          x2="373"
          y2="118"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2BAE76" stopOpacity="0.5" />
          <stop offset="0.0001" stopColor="#2BAE76" />
          <stop offset="1" stopColor="#76AC6D" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default RockyTransition;
